import React, { useState } from "react";
import { Tab, TabContent, TabPane } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Members.css";
import PillNavigation from "../../../Components/PillNavigation";
import { USER_NAV_LIST } from "../../../dummyData/dummyData";
import UnregisterUsers from "./UnregisterUsers";

function Members() {
    const [active, setActive] = useState("1"); // use string keys

    const toggle = (tab) => setActive(String(tab));

    return (
        <div className="admin-home-card">
            <PillNavigation navList={USER_NAV_LIST} active={active} toggle={toggle} />
            <Tab.Container activeKey={active}>
                <TabContent className="py-50">
                    <TabPane eventKey="1">
                        <UnregisterUsers />
                    </TabPane>
                    <TabPane eventKey="2">tab 2</TabPane>
                </TabContent>
            </Tab.Container>
        </div>
    );
}

export default Members;
